"use client";
import Overview from "@components/demos/AISpeechClassifier/views/Overview";
import Result from "@components/demos/AISpeechClassifier/views/Result";
import { createContext, useState } from "react";

const views = {
  overview: <Overview />,
  result: <Result />,
};

interface IAISpeechClassifierContext {
  probability: null | number;
  setProbability: (probability: null | number) => void;
  setView: (view: "overview" | "result") => void;
  view: "overview" | "result";
}

export const AISpeechClassifierContext = createContext<IAISpeechClassifierContext>({
  view: "overview",
  setView: () => {},
  probability: null,
  setProbability: () => {},
});

export default function AISpeechClassifier() {
  const [view, setView] = useState<"overview" | "result">("overview");
  const [probability, setProbability] = useState<null | number>(null);
  return (
    <AISpeechClassifierContext.Provider value={{ view, setView, probability, setProbability }}>
      <div className='flex h-full w-full flex-col overflow-hidden rounded-xl border shadow-lg'>{views[view]}</div>
    </AISpeechClassifierContext.Provider>
  );
}
